import React, {useState} from "react";
import styled from "styled-components";
import Button from "./Button";
import {useHistory} from "react-router-dom";
import {numberFotmat} from "../utils/utils";

const CardStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  width: 250px;
  min-width: 250px;
  padding: 24px;
  background: #fff;
  margin-bottom: 24px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  gap: 16px;
  user-select: none;
  position: relative;

  h1 {
    font-size: 18px;
  }
  h2 {
    font-size: 16px;
  }
  img {
    max-height:160px;
    max-width:100%;
  }
`;

const Actions = styled.div`
    display: flex;
    width: 100%;
    gap: 8px;
    align-items: center;

    @media (max-width: 400px) {
        flex-direction: column;
    }
`;

const QuantityInput = styled.input`
    flex: 1;
    min-width: 0;
    height: 45px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid #ccc;
    box-sizing: border-box;

    &::placeholder {
        color: #999;
    }

    &:focus {
        outline: none;
        border-color: #0077cc;
    }
`;

const ButtonWrapper = styled.div`
    flex-shrink: 0;
`;

const OutOfStock = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cc0025;
    font-weight: bold;
    font-size: 18px;
    border-radius: 16px;
`;

const CardSwap = ({
                    title,
                    points,
                    id,
                    url,
                    couponTypeId,
                    dataPoints,
                    stock,
                    stockEnabled,
                  }) => {
  let history = useHistory();
  const [quantity, setQuantity] = useState("");
  const outOfStock = stockEnabled && Number(stock) === 0;

  const goCanje = () => {
    if (outOfStock) return;
    let url = `/home/swap?customerId=${dataPoints.person.id}&productId=${id}&couponTypeId=${couponTypeId}`;
    history.push(url + `&quantity=${quantity ? quantity : 1}`);
  };

  return (
    <CardStyled id={id} style={{filter: outOfStock ? 'grayscale(100%)' : 'none'}}>
      {outOfStock && <OutOfStock>SIN STOCK</OutOfStock>}
      <h1>{title}</h1>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: "160px"}}>
        <img src={url} alt="imagen"  />
      </div>

      <h2>{numberFotmat(points) + (couponTypeId !== null ? ' CUPONES' : ' PUNTOS')}</h2>

     <Actions>
       <ButtonWrapper>
         <Button onClick={goCanje} title="CANJEAR" disabled={outOfStock}/>
       </ButtonWrapper>
       <QuantityInput
         type="number"
         min="1"
         value={quantity}
         onChange={(e) => setQuantity(e.target.value)}
         placeholder="Cant."
       />
     </Actions>
    </CardStyled>
  );
};
export default CardSwap;
